import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';
import {
  View,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
// import { Auth } from '@aws-amplify/auth';
import { confirmSignUp, signIn } from '@aws-amplify/auth';
import md5 from 'md5';

import styles from '../../styles';
import SignConfirmForm from '../../components/forms/user/SignConfirmForm';
import AORTypes from '../../types';

class SignConfirm extends React.Component {
  static async retrieveEmail() {
    try {
      const value = await AsyncStorage.getItem('email');
      if (value !== null && value !== undefined) {
        // Our data is fetched successfully
        console.log('retrieveEmail succeeded');
        console.log(value);
        return value;
      }
    } catch (error) {
      // Error retrieving data
      console.log('retrieveEmail failed');
      console.log(error);
    }

    return '';
  }

  static async retrievePassword() {
    try {
      const value = await AsyncStorage.getItem('password');
      if (value !== null && value !== undefined) {
        // Our data is fetched successfully
        console.log('retrievePassword succeeded');
        // console.log(value);
        return value;
      }
    } catch (error) {
      // Error retrieving data
      console.log('retrievePassword failed');
      console.log(error);
    }

    return '';
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'SignConfirm';

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      email: '',
      password: '',
    };
  }

  async componentDidMount() {
    const { user, history } = this.props;
    const redirect = this.getRedirect();

    if (user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }

    await SignConfirm.retrieveEmail().then((email) => this.setState({ email }));
    await SignConfirm.retrievePassword().then((password) => this.setState({ password }));
  }

  componentDidUpdate(_prevProps) {
    const { user, history } = this.props;
    const redirect = this.getRedirect();

    if (user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }
  }

  onSubmit(values) {
    const { history, getAnalyticsService } = this.props;
    const redirect = this.getRedirect();
    const { password: savedPassword } = this.state;
    const { email: savedEmail } = this.state;
    let { email } = values;

    email = email.trim();

    return confirmSignUp({
      username: md5(email),
      confirmationCode: values.code,
    })
      .then((_data) => {
        getAnalyticsService().report.event('confirm', 'user');
        console.log('success');

        if (savedEmail === email && savedPassword !== '') {
          signIn({
            username: md5(email),
            password: savedPassword,
          })
            .then(() => {
              console.log('signIn success');
              history.push(redirect);
            })
            .catch(() => {
              console.log('signIn failed');
              history.push(`/signin${redirect}`);
            });
          return null;
        }
        history.push(`/signin${redirect}`);

        return null;
      })
      .catch((err) => {
        console.log(err);
        if (err.message === 'User cannot be confirmed. Current status is CONFIRMED') {
          getAnalyticsService().report.event('confirmNotNeeded', 'user');
          history.push(`/signin${redirect}`);
          return null;
        }
        getAnalyticsService().report.error(err);
        return err.message;
      });
  }

  getRedirect() {
    const { location } = this.props;
    const match = matchPath('/confirm/:redirect', location.pathname);
    return match ? `/${match.params.redirect}` : '/';
  }

  render() {
    const { history } = this.props;
    const redirect = this.getRedirect();
    const { email } = this.state;

    return (
      <View style={styles.view.headed}>
        <SignConfirmForm
          email={email}
          redirect={redirect}
          history={history}
          onSubmit={this.onSubmit}
        />
      </View>
    );
  }
}

SignConfirm.defaultProps = {
  user: undefined,
};

SignConfirm.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  user: AORTypes.User,
  location: ReactRouterPropTypes.location.isRequired,
};

export default SignConfirm;
